var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,itemIndex){return _c('WsButton001',{key:itemIndex,staticClass:"mt-5",attrs:{"flat-button":item.flatButton,"out-line":item.outLine,"leading-icon":item.leadingIcon,"white":item.white,"red":item.red},on:{"click":function($event){return _vm.$emit('alertPopupOpen')}}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }